// extracted by mini-css-extract-plugin
export default {"wrapper":"app_wrapper__g-4wY","layout":"app_layout__gNKII","header":"app_header__PM1+g"};